"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_2 = require("vue");
var vue_3 = require("vue");
var echarts = __importStar(require("echarts"));
var index_1 = require("@/store/index");
exports.default = (0, vue_1.defineComponent)({
    __name: 'PieCharts',
    props: {
        countData: {
            type: Array,
            default: function () { return []; }
        },
        category: {
            type: Array,
            default: function () { return []; }
        },
    },
    setup: function (__props) {
        var props = __props;
        var mainStore = (0, index_1.useMainStore)();
        var dark = (0, vue_3.computed)(function () { return mainStore.isDark; });
        (0, vue_3.watch)(dark, function (_, next) {
            initCharts(next);
        });
        var myChart;
        var pieCharts = (0, vue_3.ref)();
        var initCharts = function (isDark) {
            var chartsTheme = isDark ? "light" : "dark";
            if (myChart) {
                myChart.dispose();
            }
            myChart = echarts.init(pieCharts.value, chartsTheme);
            var option;
            option = {
                title: {
                    text: '作者文章总量统计（篇）',
                    subtext: '因数量过大，本数据已去除数量小于2的作者',
                    top: 10,
                    left: 10,
                },
                tooltip: {
                    trigger: 'axis',
                    formatter: function (params) {
                        return "\n        \u4F5C\u8005\u59D3\u540D\uFF1A".concat(params[0].name, " </br> \n        \u6587\u7AE0\u6570\u91CF\uFF1A").concat(params[0].value, "\u7BC7\n        ");
                    },
                    axisPointer: {
                        type: 'shadow',
                    },
                },
                grid: {
                    left: '5%',
                    right: '5%',
                    top: '0.7%',
                    bottom: "0.1%",
                    containLabel: true
                },
                xAxis: {
                    type: 'value',
                    show: true,
                },
                yAxis: {
                    type: 'category',
                    data: props.category
                },
                series: [
                    {
                        name: '作文总数',
                        type: 'bar',
                        label: {
                            show: true,
                            position: 'right',
                            formatter: '{c}',
                        },
                        itemStyle: {
                            color: '#0dbc79'
                        },
                        data: props.countData,
                    },
                ]
            };
            option && myChart.setOption(option);
        };
        (0, vue_3.onMounted)(function () {
            initCharts(!mainStore.isDark);
        });
        return function (_ctx, _cache) {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                ref_key: "pieCharts",
                ref: pieCharts,
                style: { "height": "12000px", "width": "100%", "background-color": "white" },
                id: "main"
            }, null, 512));
        };
    }
});
